jQuery(document).ready(function ($) {
  // Parallax
  function parallaxScroll() {
    $(".js-parallax-image").each(function () {
      var $el = $(this);
      var scrollTop = $(window).scrollTop();
      var offsetTop = $el.closest(".parallax-wrap").offset().top;
      var height = $el.closest(".parallax-wrap").outerHeight();
      var distance = scrollTop - offsetTop;

      if (distance > -height && distance < $(window).height()) {
        var move = distance * 0.4;
        $el.css("transform", "translateY(" + move + "px)");
      }
    });
  }

  $(window).on("scroll", parallaxScroll);
  parallaxScroll();

  // Animation on scroll
  var $navbar = $(".sticky-nav");
  var stickyTriggered = false;

  function handleStickyNav() {
    console.log("handleStickyNav called");
    if ($(window).scrollTop() > 100) {
      if (!stickyTriggered) {
        $navbar.addClass("is-sticky");

        // ⏳ Increase this timeout for a slower slide-in feel
        setTimeout(function () {
          $navbar.addClass("in-view");
        }, 200);

        stickyTriggered = true;
      }
    } else {
      $navbar.removeClass("is-sticky in-view");
      stickyTriggered = false;
    }
  }

  $(window).on("scroll", handleStickyNav);
  handleStickyNav(); // Run once on load

  function checkInView() {
    $(
      ".animate-down, .animate-left, .animate-right, .animate-slide-in, .animate-slide-in-right"
    ).each(function () {
      var $el = $(this);
      var windowHeight = $(window).height();
      var scrollTop = $(window).scrollTop();
      var offsetTop = $el.offset().top + $(window).height() * 0.3;
      var offsetBottom = offsetTop + $el.outerHeight();

      // Element is in view
      if (offsetBottom > scrollTop && offsetTop < scrollTop + windowHeight) {
        $el.addClass("in-view");
      } else {
        $el.removeClass("in-view"); // Remove to re-trigger on re-entry
      }
    });
  }

  $(window).on("scroll resize", checkInView);
  checkInView(); // Run once on load

  // Cancel background zoom on .proven-text hover
  var $container = $(".proven-results.bg-hover-container");
  var $textBlock = $container.find(".proven-text");

  if ($container.length && $textBlock.length) {
    $textBlock.on("mouseenter", function () {
      $container.addClass("cancel-zoom");
    });

    $textBlock.on("mouseleave", function () {
      $container.removeClass("cancel-zoom");
    });
  }
});
